export type MesosFeatureButtonId =
    | "enableFaq"
    | "enableBGFreeText"
    | "enableBGDecisionTree"
    | "enableFamkaFreeText"
    | "enableKUGCalculator"
    | "enableKUGFreeText"
    | "enableALGFreeText"
    | "enableALGOtherTopics"
    | "enableALGLanding"
    | "enableKinFreeText"
    | "enableKinDecisionTree"
    | "enableStartseiteFreeText"
    | "enableSASFreeText"
    | "enableSASConsultingText"
    | "enableFormFreeText"
    | "enableInkassoFreeText"
    | "enableNavigationFreeText"
    | "enableBewerbersucheFreeText"
    | "enableLeistungenFreeText"
    | "enableEinstellungenFreeText"
    | "enableWAUFreeText"

export type MesosConfig = {
    [key in MesosFeatureButtonId]: boolean;
} & {
    chatbotApi: string;
    disableBotAllSites: boolean;
    disableBotOn: string[];
    matomoTrackingURL: string;
    dztCmsPath: string;
};

let currentEnv = process.env.NODE_ENV as "local" | "unit-test" | "prod" || "local";
switch (process.env.NODE_ENV) {
    case "development":
        currentEnv = "local";
        break;
    case "test":
        currentEnv = "unit-test";
        break;
    case "production":
        currentEnv = "prod";
        break;
    default:
        currentEnv = "local";
}

type MesosConfigs = {
    [env in typeof currentEnv]: MesosConfig;
};

const mesosConfigs: MesosConfigs = {
    "local": {
        // chatbotApi: 'http://localhost:5005',
        chatbotApi:
            "https://rest.dev.ocp.webapp.idst.ibaintern.de/portal-develop/chat/pc/v1",
        enableFaq: true,
        enableBGFreeText: true,
        enableBGDecisionTree: true,
        enableKUGCalculator: true,
        enableKUGFreeText: true,
        enableFamkaFreeText: true,
        enableInkassoFreeText: true,
        enableKinFreeText: true,
        enableKinDecisionTree: true,
        enableALGOtherTopics: true,
        enableALGLanding: true,
        enableALGFreeText: true,
        enableStartseiteFreeText: true,
        enableSASFreeText: true,
        enableSASConsultingText: true,
        enableFormFreeText: true,
        enableNavigationFreeText: true,
        enableBewerbersucheFreeText: true,
        enableLeistungenFreeText: true,
        enableEinstellungenFreeText: true,
        enableWAUFreeText: true,
        disableBotAllSites: false,
        disableBotOn: [
            // 'localhost:3333',
            // 'localhost:3333/'
        ],
        matomoTrackingURL:
            "https://web.arbeitsagentur.de/analytics/matomo/tracker/js/container_TT5eLPDL.js",
        dztCmsPath: "gateway",
    },
    "unit-test": {
        chatbotApi: "https://rest.dev.ocp.webapp.idst.ibaintern.de/portal-develop/chat/pc/v1",
        enableFaq: true,
        enableBGFreeText: true,
        enableBGDecisionTree: true,
        enableKUGCalculator: true,
        enableKUGFreeText: true,
        enableFamkaFreeText: true,
        enableKinFreeText: true,
        enableKinDecisionTree: true,
        enableALGOtherTopics: true,
        enableALGLanding: true,
        enableALGFreeText: true,
        enableStartseiteFreeText: true,
        enableSASFreeText: true,
        enableSASConsultingText: true,
        enableFormFreeText: true,
        enableInkassoFreeText: true,
        enableNavigationFreeText: true,
        enableBewerbersucheFreeText: true,
        enableLeistungenFreeText: true,
        enableEinstellungenFreeText: true,
        enableWAUFreeText: true,
        disableBotAllSites: false,
        disableBotOn: [],
        matomoTrackingURL:
            "https://web.arbeitsagentur.de/analytics/matomo/tracker/js/container_TT5eLPDL.js",
        dztCmsPath: "gateway",
    },
    "prod": {
        chatbotApi: "https://rest.arbeitsagentur.de/portal/chat/pc/v1",
        enableFaq: "true".toString() === "true",
        enableBGFreeText: "true".toString() === "true",
        enableBGDecisionTree: "true".toString() === "true",
        enableKUGCalculator: "true".toString() === "true",
        enableKUGFreeText: "true".toString() === "true",
        enableFamkaFreeText: "true".toString() === "true",
        enableKinFreeText: "true".toString() === "true",
        enableKinDecisionTree:
            "true".toString() === "true",
        enableALGOtherTopics: "true".toString() === "true",
        enableALGLanding: "true".toString() === "true",
        enableALGFreeText: "true".toString() === "true",
        enableStartseiteFreeText:
            "true".toString() === "true",
        enableSASFreeText: "true".toString() === "true",
        enableSASConsultingText:
            "true".toString() === "true",
        enableFormFreeText: "true".toString() === "true",
        enableInkassoFreeText: "true".toString() === "true",
        enableNavigationFreeText:
            "true".toString() === "true",
        enableBewerbersucheFreeText:
            "true".toString() === "true",
        enableLeistungenFreeText:
            "true".toString() === "true",
        enableEinstellungenFreeText:
            "true".toString() === "true",
        enableWAUFreeText: "true".toString() === "true",
        disableBotAllSites: "false".toString() === "true",
        // @ts-ignore
        disableBotOn: "arbeitsagentur.de/example/path|arbeitsagentur.de/example/path".split("|"),
        matomoTrackingURL: "https://web.arbeitsagentur.de/analytics/matomo/tracker/js/container_SFeDRFTH.js",
        dztCmsPath: "vor-ort",
    },
};
export const mesosConfig: MesosConfig = mesosConfigs[currentEnv];
